import React, { useCallback, useState } from 'react'
import { Grid, Typography, Tooltip, IconButton, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, useTheme, useMediaQuery } from '@material-ui/core'
import DeleteIcon from '@material-ui/icons/Delete'
import AddIcon from '@material-ui/icons/Add'
import EditIcon from '@material-ui/icons/Edit'
import FormatListNumberedIcon from '@material-ui/icons/FormatListNumbered'
import useStyles from './styles'
import { CustomButton, SecaoGenerica, ModalConfirmacao } from 'components'

import { FormAdicionarExame } from './FormAdicionarExame'
import { FormAdicionarQuesitos } from './FormAdicionarQuesitos'

export const ExamesSolicitados = (props) => {
  const { examesSolicitados, setExamesSolicitados, idCaso, route } = props
  const classes = useStyles()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'))
  const [openForm, setOpenForm] = useState(false)
  const [exameSolicitadoSelecionado, setExameSolicitadoSelecionado] = useState(null)
  const [openQuesitos, setOpenQuesitos] = useState(false)
  const [editar, setEditar] = useState(false)
  const [openConfirmDelete, setOpenConfirmDelete] = useState(false)
  const [uuidToDelete, setUuidToDelete] = useState(null)

  const handleConfirmDelete = () => {
    const novoArray = examesSolicitados.filter((exame) => exame.uuid !== uuidToDelete)
    setExamesSolicitados([...novoArray])
    setOpenConfirmDelete(false)
    setUuidToDelete(null)
  }

  const handleClickRemoverExame = useCallback(
    (uuid) => {
      setUuidToDelete(uuid)
      setOpenConfirmDelete(true)
    },
    []
  )

  const openFormAdicionarExame = () => {
    setEditar(false)
    setOpenForm(true)
  }

  const handleClickEditarExameSolicitado = (exame) => {
    setExameSolicitadoSelecionado(exame)
    setEditar(true)
    setOpenForm(true)
  }

  const handleClickAdicionarQuesito = (exame) => {
    setExameSolicitadoSelecionado(exame)
    setOpenQuesitos(true)
  }

  return (
    <Grid item xs={12}>
      <SecaoGenerica titulo="EXAMES SOLICITADOS">
        <Grid item container justifyContent="space-between" alignItems="center" className={classes.fieldGroup} spacing={2}>
          <Grid item container justifyContent="space-between">
            <Grid item />
            <Grid item style={{ marginBottom: '16px' }}>
              <CustomButton colorType="warning" onClick={openFormAdicionarExame} startIcon={<AddIcon />}>
                Adicionar Exame
              </CustomButton>
            </Grid>
          </Grid>

          <FormAdicionarExame
            aberto={openForm}
            editar={editar}
            setExamesSolicitados={setExamesSolicitados}
            setOpen={setOpenForm}
            idCaso={idCaso}
            route={route}
            exameSolicitado={exameSolicitadoSelecionado}
          />

          <FormAdicionarQuesitos
            aberto={openQuesitos}
            exameSolicitado={exameSolicitadoSelecionado}
            setExamesSolicitados={setExamesSolicitados}
            setOpen={setOpenQuesitos}
          />

          <ModalConfirmacao
            aberto={openConfirmDelete}
            onClose={() => setOpenConfirmDelete(false)}
            onConfirm={handleConfirmDelete}
            titulo="Remover Exame"
            confirmarLabel="Remover"
            confirmarColor="error"
          >
            <Typography variant="body1">Tem certeza que deseja remover este exame solicitado?</Typography>
          </ModalConfirmacao>

          <Grid item md={12} sm={12} xs={12}>
            {isMobile ? (
              <div className={classes.mobileContainer}>
                {examesSolicitados.length ? (
                  examesSolicitados.map((exameSolicitado) => (
                    <CardExameSolicitadoMobile
                      key={exameSolicitado.uuid}
                      exameSolicitado={exameSolicitado}
                      handleClickRemoverExame={handleClickRemoverExame}
                      handleClickEditarExameSolicitado={handleClickEditarExameSolicitado}
                      handleClickAdicionarQuesito={handleClickAdicionarQuesito}
                    />
                  ))
                ) : (
                  <div className={classes.mobileCard} style={{ textAlign: 'center' }}>
                    <Typography className={classes.emptyState}>Nenhum exame solicitado</Typography>
                  </div>
                )}
              </div>
            ) : (
              <TableContainer className={classes.tableContainer}>
                <Table aria-label="collapsible table" size="small">
                  <TableHead>
                    <TableRow className={classes.tableHeader}>
                      <TableCell style={{ width: '30%' }}>
                        <Typography style={{ fontSize: '13px', fontWeight: 'bold' }}>Tipo</Typography>
                      </TableCell>
                      <TableCell style={{ width: '40%' }}>
                        <Typography style={{ fontSize: '13px', fontWeight: 'bold' }}>Setor</Typography>
                      </TableCell>
                      <TableCell>
                        <Typography style={{ fontSize: '13px', fontWeight: 'bold' }}>Objetos examinados</Typography>
                      </TableCell>
                      <TableCell />
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {examesSolicitados.length ? (
                      examesSolicitados.map((exameSolicitado) => (
                        <LinhaTabelaExameSolicitado key={exameSolicitado.uuid} exameSolicitado={exameSolicitado} handleClickRemoverExame={handleClickRemoverExame} handleClickEditarExameSolicitado={handleClickEditarExameSolicitado} handleClickAdicionarQuesito={handleClickAdicionarQuesito} />
                      ))
                    ) : (
                      <TableRow className={classes.tableRow}>
                        <TableCell colSpan={7} style={{ textAlign: 'center', padding: '20px' }}>
                          <Typography>Nenhum exame solicitado</Typography>
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            )}
          </Grid>
        </Grid>
      </SecaoGenerica>
    </Grid>
  )
}

const LinhaTabelaExameSolicitado = (props) => {
  const { exameSolicitado, handleClickRemoverExame, handleClickEditarExameSolicitado, handleClickAdicionarQuesito } = props
  const classes = useStyles()

  return (
    <>
      <TableRow className={classes.tableRow}>
        <TableCell>
          <Typography style={{ fontSize: '13px' }}>{exameSolicitado.tipoEx?.nome}</Typography>
        </TableCell>
        <TableCell>
          <Typography style={{ fontSize: '13px' }}>
            {exameSolicitado?.setor?.nome} - {exameSolicitado?.setor?.divisao.regional.nome}
          </Typography>
        </TableCell>
        <TableCell>
          <Typography style={{ fontSize: '13px' }}>
            {exameSolicitado.cadavs?.length ? <div>{exameSolicitado.cadavs.map((c) => `NIC: ${c.nic}`).join('; ')}</div> : <></>}
            {exameSolicitado.perics?.length ? <div>{exameSolicitado.perics.map((p) => p.nome).join('; ')}</div> : <></>}
            {exameSolicitado.veiculos?.length ? <div>{exameSolicitado.veiculos.map((ve) => ve.descricao).join('; ')}</div> : <></>}
            {exameSolicitado.vests?.length ? (
              <div>
                {exameSolicitado.vests.map((v) => (
                  <div key={v.identificador}>{v.identificador}</div>
                ))}{' '}
              </div>
            ) : (
              <></>
            )}
            {exameSolicitado.locais?.length ? <div>{exameSolicitado.locais.map((l) => `${l.rua ? `${l.rua} - ` : ''}  ${l.cidade}`).join('; ')}</div> : <></>}
            {!exameSolicitado.locais?.length && !exameSolicitado.vests?.length && !exameSolicitado.perics?.length && !exameSolicitado.cadavs?.length && !exameSolicitado.veiculos?.length ? 'Nenhum objeto' : ''}
          </Typography>
        </TableCell>
        <TableCell>
          <Tooltip title="Quesitos" style={{ marginRight: '10px' }}>
            <IconButton size="small" onClick={() => handleClickAdicionarQuesito(exameSolicitado)}>
              <FormatListNumberedIcon fontSize="small" />
            </IconButton>
          </Tooltip>
          <Tooltip title="Editar exame" style={{ marginRight: '10px' }}>
            <IconButton size="small" onClick={() => handleClickEditarExameSolicitado(exameSolicitado)}>
              <EditIcon fontSize="small" />
            </IconButton>
          </Tooltip>
          <Tooltip title="Remover exame">
            <IconButton size="small" onClick={() => handleClickRemoverExame(exameSolicitado.uuid)}>
              <DeleteIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </TableCell>
      </TableRow>
    </>
  )
}

const CardExameSolicitadoMobile = (props) => {
  const { exameSolicitado, handleClickRemoverExame, handleClickEditarExameSolicitado, handleClickAdicionarQuesito } = props
  const classes = useStyles()
  const theme = useTheme()
  const isDark = theme.palette.type === 'dark'

  const getObjetosTags = (exame) => {
    const tags = []
    if (exame.cadavs?.length) {
      exame.cadavs.forEach((c) => tags.push({ label: `CADÁVER: ${c.nic}`, type: 'default' }))
    }
    if (exame.perics?.length) {
      exame.perics.forEach((p) => tags.push({ label: `PERICIANDO: ${p.nome || p.alcunha || 'NÃO INFORMADO'}`, type: 'default' }))
    }
    if (exame.veiculos?.length) {
      exame.veiculos.forEach((ve) => tags.push({ label: `VEÍCULO: ${ve.placa || ve.identificador || ve.descricao || 'NÃO INFORMADO'}`, type: 'default' }))
    }
    if (exame.vests?.length) {
      exame.vests.forEach((v) => tags.push({ label: `VESTÍGIO: ${v.identificador}`, type: 'primary' }))
    }
    if (exame.locais?.length) {
      exame.locais.forEach((l) => tags.push({ label: `LOCAL: ${l.rua ? `${l.rua}, ` : ''}${l.cidade}`, type: 'default' }))
    }
    return tags
  }

  const tags = getObjetosTags(exameSolicitado)

  const getTagStyle = (type) => {
    if (type === 'primary') {
      return {
        backgroundColor: isDark ? 'rgba(33, 150, 243, 0.15)' : '#EBF5FF',
        color: isDark ? '#90CAF9' : '#0066CC',
        border: isDark ? '1px solid rgba(33, 150, 243, 0.3)' : '1px solid #C2E0FF',
      }
    }
    return {
      backgroundColor: isDark ? 'rgba(255, 255, 255, 0.05)' : '#F1F3F5',
      color: isDark ? '#E0E0E0' : '#495057',
      border: isDark ? '1px solid rgba(255, 255, 255, 0.1)' : '1px solid #E9ECEF',
    }
  }

  return (
    <div className={classes.mobileCard}>
      <div className={classes.mobileHeader}>
        <Typography className={classes.mobileActionTitle}>
          {exameSolicitado.tipoEx?.nome}
        </Typography>
        <div style={{ display: 'flex', gap: '4px', flexShrink: 0 }}>
          <Tooltip title="Quesitos">
            <IconButton size="small" onClick={() => handleClickAdicionarQuesito(exameSolicitado)}>
              <FormatListNumberedIcon fontSize="small" />
            </IconButton>
          </Tooltip>
          <Tooltip title="Editar exame">
            <IconButton size="small" onClick={() => handleClickEditarExameSolicitado(exameSolicitado)}>
              <EditIcon fontSize="small" />
            </IconButton>
          </Tooltip>
          <Tooltip title="Remover exame">
            <IconButton size="small" onClick={() => handleClickRemoverExame(exameSolicitado.uuid)}>
              <DeleteIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </div>
      </div>
      <div className={classes.mobileDetailRow}>
        <Typography className={classes.mobileDetailItem} variant="body2">
          Setor: <span title={`${exameSolicitado?.setor?.nome || ''} - ${exameSolicitado?.setor?.divisao?.regional?.nome || ''}`}>{exameSolicitado?.setor?.nome} - {exameSolicitado?.setor?.divisao?.regional?.nome}</span>
        </Typography>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', marginTop: '4px' }}>
          <Typography variant="body2" style={{ fontSize: '0.8125rem', color: theme.palette.text.secondary, fontWeight: 500 }}>
            Objetos examinados:
          </Typography>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
            {tags.length ? (
              tags.map((tag, index) => (
                <div
                  key={index}
                  style={{
                    borderRadius: '6px',
                    padding: '3px 8px',
                    fontSize: '0.75rem',
                    fontWeight: 500,
                    display: 'inline-flex',
                    alignItems: 'center',
                    ...getTagStyle(tag.type),
                  }}
                >
                  {tag.label}
                </div>
              ))
            ) : (
              <span style={{ fontSize: '0.75rem', color: theme.palette.text.secondary, fontStyle: 'italic' }}>
                Nenhum objeto
              </span>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
